import { NbAuthComponent, NbLoginComponent } from '@nebular/auth';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { HostListener } from '@angular/core';
import { BASE_PATH_SERVER, pathJoin } from '@src/environments/configs';
import { environment } from '@src/environments/environment';


export enum LoginType {
  User = 'user',
  Admin = 'admin',
  Operator = 'operator',
}

@Component(
  {
    selector: 'nb-login',
    templateUrl: './hm-login-component.html',
    styleUrls: ['./hm-login-component.scss'],
  })

export class HmLoginComponent extends NbLoginComponent {

  isDebug: boolean = environment.debug;

  //currentLoginSelection: LoginType;

  login() {
    return super.login();
  }

  get isLoginOperator(): boolean {
    return this.user?.role === LoginType.Operator;
  }

  get isLoginUser(): boolean {
    return this.user?.role === LoginType.User;
  }

  get isLoginAdmin(): boolean {
    return this.user?.role === LoginType.Admin;
  }

  get isLoginUndef(): boolean {
    return this.user?.role == null;
  }

  /*
  metodo invocato da target saml al termine di autenticazione con carta
  */
  @HostListener('window:HmSamlLoginCb', ['$event'])
  loginSaml = function (event) {
    // console.log("HmSamlLoginCb " + JSON.stringify(event.detail))
    const _this = this;
    this.errors = this.messages = [];
    this.submitted = true;
    this.service.authenticate('saml', event.detail).subscribe(function (result) {
      _this.submitted = false;
      if (result.isSuccess()) {
        _this.messages = result.getMessages();
      } else {
        _this.errors = result.getErrors();
      }
      const redirect = result.getRedirect();
      if (redirect) {
        setTimeout(function () {
          return _this.router.navigateByUrl(redirect);
        }, _this.redirectDelay);
      }
    });
  };

  showAdminLogin() {
    if (this.isLoginAdmin) {
      this.resetLogin();
    } else {
      this.resetLogin(LoginType.Admin);
    }
  }

  showOperatorLogin() {
    if (this.isLoginOperator) {
      this.resetLogin();
    } else {
      this.resetLogin(LoginType.Operator);
    }
  }

  resetLogin(role = null) {
    this.user = new Object();
    this.user.role = role;
  }

  showUserLogin() {
    if (this.isLoginUser) {
      this.resetLogin();
    } else {
      this.resetLogin(LoginType.User);
    }
  }

  @HostListener('window:HmArpaV2Login', ['$event'])
  loginArpaV2 = function (event) {
    const _this = this;
    if (event.detail){
      if (event.detail.error){
        _this.errors = [event.detail.error];
        //alert(event.detail.error);
        if (event.detail.id_token){
          const iframe = document.createElement('iframe');
          iframe.setAttribute('src', environment.arpa_oauth2_logout +
                "?post_logout_redirect_uri=" +
                window.location.origin + 
                "&id_token_hint=" + 
                event.detail.id_token);
          document.body.appendChild(iframe);
          setTimeout(() => {
            document.body.removeChild(iframe);
          }, 1000);
        }
      }else{
        _this.errors = []
        console.log(event.detail);
        window.localStorage.setItem('auth_app_token', JSON.stringify({
          "name": "nb:auth:oauth2:token",
          "ownerStrategyName": "email",
          "createdAt": new Date().getTime(),
          "value": JSON.stringify(event.detail)
        }));
        //_this.router.navigateByUrl("/");
        window.location.href = "/";
      }
    }else{
      _this.errors = ["No valid response received"];
      //alert("No valid response received");
    }
    
  }

  openArpaV2Operatore(){
    window.open("/api/v3/oauth2/operatore/auth","_blank");
  }

  openArpaV2Cittadino(){
    window.open("/api/v3/oauth2/cittadino/auth","_blank");
    //window.location.href = "/api/v3/oauth2/cittadino/auth";
  }

  openLoginPazienteSpagentTab() {
    window.open(this.login_paziente_spagent_url, '_blank');
  }

  openLoginOperatoreSpagentTab() {
    window.open(this.login_operatore_spagent_url, '_blank');
  }

  get login_operatore_spagent_url(): string {
    return pathJoin([BASE_PATH_SERVER, 'spagent/operatore/login']);
  }

  get login_paziente_spagent_url(): string {
    return pathJoin([BASE_PATH_SERVER, 'spagent/cittadino/login']);
  }

  get login_spid_url(): string {
    return pathJoin([BASE_PATH_SERVER, 'spid/login']);
  }


}
